var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M456.354 334.396a28.223 28.223 0 0 0-1.536-2.321c-5.171-7.228-12.86-12.006-21.632-13.449a33.072 33.072 0 0 0-24.781 5.786l-95.403 68.122h-99.669c-4.702 0-8.533-3.823-8.533-8.533s3.831-8.533 8.533-8.533H268.8c16.469 0 29.867-13.397 29.867-29.867 0-.094-.009-.879-.017-.964-.529-16.461-14.413-29.295-30.532-28.902h-111.01a42.822 42.822 0 0 0-26.974 9.907l-41.728 34.731a8.558 8.558 0 0 0-3.072 6.562v102.4a8.53 8.53 0 0 0 8.533 8.533h211.721a59.872 59.872 0 0 0 38.025-13.73l103.45-85.478c14.053-10.012 18.132-29.45 9.291-44.264zm-19.669 30.737L332.74 450.987a42.82 42.82 0 0 1-27.162 9.813H102.4v-89.865l38.664-32.188c4.54-3.78 10.283-5.897 16.12-5.948l111.206-.008c7.074-.009 12.979 5.342 13.21 12.809 0 7.057-5.743 12.8-12.8 12.8h-55.467c-14.114 0-25.6 11.486-25.6 25.6s11.486 25.6 25.6 25.6h102.4a8.646 8.646 0 0 0 4.975-1.587l97.638-69.726c3.516-2.526 7.791-3.507 12.075-2.825 4.275.708 8.013 3.029 10.581 6.613.256.35.486.708.708 1.075 4.319 7.229 2.313 16.726-5.025 21.983z",
    fill: "#FFE082",
    opacity: 1,
    "data-original": "#FFE082",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.611 349.867H0v17.067h85.077v128H0V512h93.611a8.53 8.53 0 0 0 8.533-8.533V358.4a8.53 8.53 0 0 0-8.533-8.533z",
    fill: "#FFE082",
    opacity: 1,
    "data-original": "#FFE082",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.667 426.667c-14.114 0-25.6 11.486-25.6 25.6s11.486 25.6 25.6 25.6 25.6-11.486 25.6-25.6-11.486-25.6-25.6-25.6zm0 34.133c-4.702 0-8.533-3.823-8.533-8.533 0-4.71 3.831-8.533 8.533-8.533s8.533 3.823 8.533 8.533c0 4.71-3.831 8.533-8.533 8.533zM503.467 264.533H8.533A8.53 8.53 0 0 0 0 273.066c0 32.93 26.795 59.733 59.733 59.733h392.533c32.93 0 59.733-26.803 59.733-59.733a8.524 8.524 0 0 0-8.532-8.533zm-51.2 51.2H59.733c-20.608 0-37.845-14.686-41.805-34.133h476.143c-3.959 19.447-21.196 34.133-41.804 34.133z",
    fill: "#FFE082",
    opacity: 1,
    "data-original": "#FFE082",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 42.667c-122.334 0-221.867 99.533-221.867 221.867v8.533a8.53 8.53 0 0 0 8.533 8.533h426.667a8.525 8.525 0 0 0 8.533-8.533v-8.533C477.867 142.199 378.342 42.667 256 42.667zM51.2 264.533c0-112.922 91.878-204.8 204.8-204.8s204.8 91.878 204.8 204.8H51.2z",
    fill: "#FFE082",
    opacity: 1,
    "data-original": "#FFE082",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.644 140.006a190.753 190.753 0 0 0-16.435 21.342l14.225 9.429a174.385 174.385 0 0 1 14.967-19.439l-12.757-11.332zM256 76.8c-47.923.026-93.551 18.133-128.469 50.961l11.691 12.433c31.744-29.85 73.224-46.302 116.787-46.327L256 76.8zM230.4 0h51.2v17.067h-51.2z",
    fill: "#FFE082",
    opacity: 1,
    "data-original": "#FFE082",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.467 8.533h17.067V51.2h-17.067z",
    fill: "#FFE082",
    opacity: 1,
    "data-original": "#FFE082",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodDelivery);
export default __webpack_public_path__ + "static/media/food-delivery.07bc42d1b370ba9a908f2cf628bd4f09.svg";
export { ForwardRef as ReactComponent };